import { render, staticRenderFns } from "./ShiftEdit.vue?vue&type=template&id=4d54d6c6&scoped=true&"
import script from "./ShiftEdit.vue?vue&type=script&lang=js&"
export * from "./ShiftEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShiftEdit.vue?vue&type=style&index=0&id=4d54d6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d54d6c6",
  null
  
)

export default component.exports